import Vue from 'vue'

const DUMMY_CPF = '01234567890'
const PASSPORT_PATTERN = /^[A-Za-z]{2}[0-9]{6}$/

function parsePayload(booking) {
  if (!booking) return
  if (typeof booking.payload === 'string') {
    try {
      Vue.set(booking, 'payload', JSON.parse(booking.payload))
    } catch (error) {
      Vue.set(booking, 'payload', {})
    }
  }
  if (!booking.payload || typeof booking.payload !== 'object') {
    Vue.set(booking, 'payload', {})
  }
}

function tableText(booking) {
  return (booking && booking.people && booking.people.tableText) || null
}

function documentFromCostumer(costumer) {
  if (!costumer || typeof costumer !== 'object') return ''
  return String(
    costumer.cpf ||
      costumer.doc ||
      costumer.cpf_cnpj ||
      costumer.document ||
      costumer.passport ||
      ''
  ).trim()
}

function paymentDocument(payment) {
  if (!payment) return ''
  const origin = payment.data_origin || {}
  return String(
    origin.payer_cpf ||
      origin.payer_cnpj ||
      origin.customer_document ||
      origin.payer_document ||
      payment.payer_cpf ||
      payment.customer_document ||
      payment.doc ||
      ''
  ).trim()
}

function identityCandidates(booking) {
  const values = []
  const costumer = booking && booking.payload && booking.payload.costumer
  values.push(documentFromCostumer(costumer))
  if (booking && booking.cpf) values.push(String(booking.cpf).trim())

  const payments = (booking && booking.payments) || []
  for (let i = 0; i < payments.length; i += 1) {
    values.push(paymentDocument(payments[i]))
  }

  const payloadPayments =
    (booking && booking.payload && booking.payload.payments) || []
  for (let i = 0; i < payloadPayments.length; i += 1) {
    values.push(paymentDocument(payloadPayments[i]))
  }

  return values.filter(Boolean)
}

export function isCompleteIdentityDoc(doc) {
  const value = String(doc || '').trim()
  if (!value) return false
  if (/[A-Za-z]/.test(value)) {
    return PASSPORT_PATTERN.test(value.replace(/\s/g, '').toUpperCase())
  }
  const digits = value.replace(/\D/g, '')
  if (!digits || /^0+$/.test(digits)) return false
  if (digits === DUMMY_CPF) return false
  return digits.length === 11 || digits.length === 14
}

export function bookingOwnerName(booking) {
  const costumer = booking && booking.payload && booking.payload.costumer
  const fromCostumer = costumer && String(costumer.name || '').trim()
  if (fromCostumer) return fromCostumer

  const table = tableText(booking)
  const fromOwner = table && String(table.groupOwner || '').trim()
  if (fromOwner) return fromOwner

  const line1 = table && table.line1
  if (!line1) return ''
  return String(line1)
    .replace('Visitante (', '')
    .replace(/\)/g, '')
    .split('(')[0]
    .trim()
}

export function bookingOwnerCpf(booking) {
  const candidates = identityCandidates(booking)
  for (let i = 0; i < candidates.length; i += 1) {
    if (isCompleteIdentityDoc(candidates[i])) return candidates[i]
  }
  return candidates[0] || ''
}

export function isMissingIdentityDocument(booking) {
  return !isCompleteIdentityDoc(bookingOwnerCpf(booking))
}

export function isMissingFullName(name) {
  const value = String(name || '').trim()
  if (!value || value === 'nome não informado') return true
  const parts = value.split(/\s+/).filter((part) => /[A-Za-zÀ-ÿ]/.test(part))
  return parts.length < 2
}

export function ensureBookingCostumer(booking) {
  if (!booking || typeof booking !== 'object') return booking
  parsePayload(booking)
  if (
    !booking.payload.costumer ||
    typeof booking.payload.costumer !== 'object'
  ) {
    Vue.set(booking.payload, 'costumer', {})
  }
  const costumer = booking.payload.costumer
  if (!String(costumer.name || '').trim()) {
    Vue.set(costumer, 'name', bookingOwnerName(booking))
  }
  if (!isCompleteIdentityDoc(costumer.cpf)) {
    Vue.set(costumer, 'cpf', bookingOwnerCpf(booking))
  }
  return booking
}
